module.exports = __webpack_public_path__ + "static/media/cancel-1.cfdbafe3.png";